"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ShipmentCardContainerStyles = require("../../styles/ShipmentCardContainerStyles");

var _ShipmentCard = _interopRequireDefault(require("./ShipmentCard"));

var _ShipmentCardGroup = _interopRequireDefault(require("./ShipmentCardGroup"));

var _excluded = ["items", "onClick"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ShipmentCardContainer = function ShipmentCardContainer(_ref) {
  var items = _ref.items,
      _onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(items),
      _useState2 = _slicedToArray(_useState, 2),
      getItems = _useState2[0],
      setItems = _useState2[1];

  var allSelected = getItems.map(function (item) {
    return item.selected;
  }).every(Boolean);
  var atLeastOneSelected = getItems.filter(function (item) {
    return item.selected;
  }).length > 0;
  var isCleanSelected = allSelected || atLeastOneSelected;

  var selectAll = function selectAll() {
    var tickets = getItems.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        selected: !isCleanSelected
      });
    });
    setItems(tickets);
  };

  var selectItem = function selectItem(id) {
    var tickets = getItems.map(function (item) {
      return item.id === id ? _objectSpread(_objectSpread({}, item), {}, {
        selected: !item.selected
      }) : item;
    });
    setItems(tickets);
  };

  return /*#__PURE__*/_react["default"].createElement("div", props, /*#__PURE__*/_react["default"].createElement(_ShipmentCardContainerStyles.Wrapper, null, /*#__PURE__*/_react["default"].createElement(_ShipmentCardContainerStyles.TitleWrapper, null, /*#__PURE__*/_react["default"].createElement(_ShipmentCardContainerStyles.Title, null, "\xD3rdenes"), getItems.length > 0 && /*#__PURE__*/_react["default"].createElement(_ShipmentCardContainerStyles.ButtonSelectAll, {
    onClick: selectAll
  }, isCleanSelected ? 'Limpiar selección' : 'Seleccionar todo')), getItems.length === 0 && /*#__PURE__*/_react["default"].createElement(_ShipmentCardContainerStyles.NoItemsSection, null, /*#__PURE__*/_react["default"].createElement(_ShipmentCardContainerStyles.NoItemsWrapper, null, /*#__PURE__*/_react["default"].createElement(_ShipmentCardContainerStyles.NoItemsTitle, null, "No hay viajes disponibles"), /*#__PURE__*/_react["default"].createElement(_ShipmentCardContainerStyles.NoItemsIcon, null))), /*#__PURE__*/_react["default"].createElement(_ShipmentCardContainerStyles.ItemsSection, null, getItems.map(function (item) {
    return item.tickets.length > 1 ? /*#__PURE__*/_react["default"].createElement(_ShipmentCardGroup["default"], {
      id: item.id,
      className: item.className,
      shipment: item.shipment,
      tickets: item.tickets,
      onSelect: function onSelect() {
        return selectItem(item.id);
      },
      onClick: function onClick(event) {
        return _onClick(event, item.id);
      },
      selected: item.selected,
      key: item.id
    }) : /*#__PURE__*/_react["default"].createElement(_ShipmentCard["default"], {
      id: item.id,
      className: item.className,
      shipment: item.shipment,
      ticket: item.tickets[0],
      onSelect: function onSelect() {
        return selectItem(item.id);
      },
      onClick: function onClick(event) {
        return _onClick(event, item.id);
      },
      selected: item.selected,
      key: item.id
    });
  })), /*#__PURE__*/_react["default"].createElement(_ShipmentCardContainerStyles.ButtonWrapper, null, /*#__PURE__*/_react["default"].createElement(_ShipmentCardContainerStyles.Button, null, /*#__PURE__*/_react["default"].createElement(_ShipmentCardContainerStyles.ButtonTitle, null, "Auto-asignar cita/transporte")))));
};

ShipmentCardContainer.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].exact({
    id: _propTypes["default"].number,
    className: _propTypes["default"].string,
    shipment: _propTypes["default"].string,
    tickets: _propTypes["default"].arrayOf(_propTypes["default"].exact({
      id: _propTypes["default"].number,
      number: _propTypes["default"].string,
      companyLogo: _propTypes["default"].string,
      courierLogo: _propTypes["default"].string,
      status: _propTypes["default"].string,
      level: _propTypes["default"].number,
      location: _propTypes["default"].string,
      datetime: _propTypes["default"].string,
      expeditionClass: _propTypes["default"].string,
      tags: _propTypes["default"].arrayOf(_propTypes["default"].exact({
        id: _propTypes["default"].string,
        description: _propTypes["default"].string
      })),
      maneuverIcon: _propTypes["default"].element
    }))
  })),
  onClick: _propTypes["default"].func
};
ShipmentCardContainer.defaultProps = {
  items: [],
  onClick: function onClick() {}
};
var _default = ShipmentCardContainer;
exports["default"] = _default;